<template>

  <v-container v-if="loading_quotation">
    <v-row>
      <v-col
        v-for="index in 8"
        :key="index"
        cols="3"
        md="3"
      >
        <v-skeleton-loader class="mx-auto border" max-width="225" max-height="185" type="image"></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
  <v-row v-else>
    <v-col cols="12">
      <v-label class="text-component mb-0">
        Selecciona hasta 3 transportistas para tu orden ({{ selectedQuotations.length }}/3 seleccionados)
      </v-label>
      <v-label v-if="total_quotations <= 3" class="text-success d-block mt-2">
        Se seleccionaron automáticamente todos los transportistas disponibles
      </v-label>
    </v-col>


    <v-col cols="3" class="container-card-fee" v-for="(quotation, index) in quotations" :key="index"
      @click="toggleQuotationSelection(quotation)">
      <div class="content-card-order">
        <v-card class="custom-card" 
          :class="{ 
            'disabled-card': !isQuotationSelected(quotation), 
            'enabled-card': isQuotationSelected(quotation) 
          }">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="d-flex justify-content-center position-relative">
                  <v-avatar color="surface-variant" size="80" :image="quotation.logistic?.profile_picture_url || quotation.idriver?.profile_picture_url"></v-avatar>
                  <v-chip 
                    v-if="isQuotationSelected(quotation)" 
                    color="success" 
                    size="small" 
                    class="position-absolute" 
                    style="top: 0; right: 10px;">
                    <v-icon size="small">mdi-check</v-icon>
                  </v-chip>
                </div>
                <div class="d-flex justify-content-center">
                  <v-label class="title-card-fee mt-3 mb-2">{{ quotation.logistic != null ? quotation.logistic.name : quotation.idriver != null ? quotation.idriver.name : "" }}</v-label>
                </div>
                <div class="d-flex justify-content-center mb-0">
                  <v-label class="title-card-fee">$ {{ quotation.price }}</v-label>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-col>
    </v-row>
    <v-pagination
        v-model="current_page"
        :length="totalPages"
        @input="updatePage"
        @next="updatePage"
        @prev="updatePage"
        @first="updatePage"
        @update:modelValue="updatePage"
      ></v-pagination>
</template>


<script>
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  mixins: [ValidMixin],
  components: { },
  props: {
    loading_quotation: Boolean,
    quotations: Array,
    selectedQuotations: Array, // Cambiado de selectedQuotation a selectedQuotations (array)
    total_quotations: Number,
    items_per_page: Number
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      name: "",
      current_page: 1
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total_quotations / this.items_per_page);
    },
  },
  watch: {
    quotations(newQuotations) {
      // Auto-selección si hay 3 o menos cotizaciones
      if (newQuotations.length > 0 && newQuotations.length <= 3 && this.selectedQuotations.length === 0) {
        console.log("🟣 [STEP 1] Auto-seleccionando", newQuotations.length, "transportistas");
        this.$emit('handleSelectMultipleQuotations', [...newQuotations]);
      }
    }
  },
  mounted() {
    // Auto-selección al montar si hay 3 o menos
    if (this.quotations.length > 0 && this.quotations.length <= 3 && this.selectedQuotations.length === 0) {
      console.log("🟣 [STEP 1 - MOUNTED] Auto-seleccionando", this.quotations.length, "transportistas");
      this.$emit('handleSelectMultipleQuotations', [...this.quotations]);
    }
  },
  methods: {
    updatePage(page) {
      this.$emit('updatePage', page); 
    },
    isQuotationSelected(quotation) {
      return this.selectedQuotations.some(q => this.isSameQuotation(q, quotation));
    },
    isSameQuotation(q1, q2) {
      // Comparar por logistic_id o idriver_id
      if (q1.logistic && q2.logistic) {
        return q1.logistic.id === q2.logistic.id;
      }
      if (q1.idriver && q2.idriver) {
        return q1.idriver.id === q2.idriver.id;
      }
      return false;
    },
    toggleQuotationSelection(quotation) {
      const isSelected = this.isQuotationSelected(quotation);
      
      if (isSelected) {
        // Deseleccionar
        const newSelection = this.selectedQuotations.filter(q => !this.isSameQuotation(q, quotation));
        this.$emit('handleSelectMultipleQuotations', newSelection);
      } else {
        // Seleccionar (máximo 3)
        if (this.selectedQuotations.length < 3) {
          const newSelection = [...this.selectedQuotations, quotation];
          this.$emit('handleSelectMultipleQuotations', newSelection);
        } else {
          this.toast.warning("Solo puedes seleccionar hasta 3 transportistas");
        }
      }
    },
  },
};
</script>